<template>
  <Content class="main-support" v-if="$locale">
    <Header :options="{ remove: ['user'] }">
      <template v-slot:user>
        <a class="avatar close-btn" @click="goHome">
          <figure><iconic name="times" /></figure>
        </a>
      </template>
    </Header>
    <div class="main-support-content">
      <Sticky class="main-support-title">
        <div class="main">{{ $locale["contact_us"] }}</div>
      </Sticky>
      <div class="main-support-list">
        <div class="main">
          <Collapse ref="collapse" :title="`<b>${$locale['technical_support']}</b>`" :settings="{ opened: true }">
            <div class="collapse-container semantic">
              <ContactUs />
            </div>
          </Collapse>
          <Collapse ref="collapse" :title="`<b>${$locale['words']['legal']}</b>`">
            <div class="collapse-container semantic">
              <ul list-padding-bottom>
                <li>
                  <router-link to="/terms">{{ $locale["terms_and_conditions"] }}</router-link>
                </li>
                <li>
                  <router-link to="/privacy">{{ $locale["privacy_policy"] }}</router-link>
                </li>
              </ul>
            </div>
          </Collapse>
          <Collapse ref="collapse" :title="`<b>${$locale['billing_support']}</b>`">
            <div class="collapse-container semantic">
              <Billing />
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import Header from "../home/Header.vue";
import Sticky from "../widgets/Sticky.vue";
import Content from "../widgets/Content.vue";
import Collapse from "../widgets/Collapse.vue";
import ContactUs from "./ContactUs.vue";
import Billing from "./Billing.vue";
export default {
  metaInfo: {
    title: "Support - My Fans 1A",
  },
  components: { Header, Sticky, Content, Collapse, ContactUs, Billing },
};
</script>

<style lang="scss">
.main-support {
  &-content {
    margin: $header_height 0 0 0;
  }
  &-title {
    padding: $mpadding;
    font-size: 2rem;
    background-color: #fff;
    z-index: 1;
  }
  &-list {
    padding: $mpadding;
    > .main {
      background-color: #fff;
      border: solid 1px $alto;
      border-radius: $mpadding/4;
      overflow: hidden;
    }
    .collapse {
      &:not(:last-child) {
        border-bottom: solid 1px $alto;
      }
      &.open {
        .collapse-header {
          border-bottom: solid 1px $alto;
        }
      }
      &-header {
        padding: $mpadding $mpadding;
      }
      &-container {
        padding: $mpadding $mpadding;
      }
    }
  }
  h1,
  h2,
  h3,
  h4 {
    font-size: 100%;
    font-weight: normal;
  }

  @include screen($tablet_width) {
    &-list {
      .collapse {
        &-header {
          padding: $mpadding $mpadding;
        }
        &-container {
          padding: $mpadding * 2;
        }
      }
    }
  }
}
</style>
